// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"e70d5c53","491":"28820483","725":"12edcbae","836":"a8f47c98","936":"470af519"}[chunkId] + ".chunk.js";
};